import { useWeb3 } from '@/hooks'
import { Box, Button, Heading } from '@chakra-ui/react'
import { useSwitchChain } from 'wagmi'

export const WrongNetworkMessage = () => {
  const { chain } = useWeb3()
  const { switchChain } = useSwitchChain()

  const handleSwitchNetwork = () => {
    switchChain({ chainId: chain?.id })
  }

  return (
    <Box m={'auto'} maxW={800} color={'primary.500'} mt={16} textAlign="center">
      <Heading px={[4, 24, 48]} as="h2" size={['md', 'lg']}>
        Please switch to the correct network to continue using the app.
      </Heading>
      <Button onClick={handleSwitchNetwork} variant={'outline'} mt={4}>
        Switch to {chain?.name}
      </Button>
    </Box>
  )
}
